import { SceneDsLink } from 'dragonmouse-shared/interfaces';
import ActiveDesignSystemSection from '../ActiveDesignSystemSection';
import * as S from './styles';

interface ActiveDsPanelProps {
	selection: SceneDsLink;
	onUpgrade?: () => Promise<void>;
	onClose: () => void;
	onShowLinkPanel: () => void;
}

const ActiveDsPanel = ({ selection, onUpgrade, onClose, onShowLinkPanel }: ActiveDsPanelProps) => {
	const { designSystem, linkedVersion, latestPublishedVersion } = selection;

	const updatePendingState: 'publishing' | 'ready' | null = (() => {
		const promptStatus = latestPublishedVersion.manifest?.promptGenerationStatus;
		if (promptStatus === 'pending' || promptStatus === 'generating') {
			return 'publishing';
		}
		if (
			linkedVersion.versionNumber < latestPublishedVersion.versionNumber &&
			promptStatus === 'complete'
		) {
			return 'ready';
		}
		return null;
	})();

	return (
		<>
			<ActiveDesignSystemSection
				activeDesignSystem={designSystem}
				linkedVersion={linkedVersion}
				latestPublishedVersion={latestPublishedVersion}
				onUpgrade={onUpgrade}
				onClose={onClose}
				updatePendingState={updatePendingState}
			/>
			<S.SectionDivider />
			<S.DropdownSection>
				<S.ChangeLink onClick={onShowLinkPanel}>
					<S.ChangeLinkText>Switch Design System</S.ChangeLinkText>
					<S.ChangeLinkArrow>→</S.ChangeLinkArrow>
				</S.ChangeLink>
			</S.DropdownSection>
		</>
	);
};

export default ActiveDsPanel;
